import { apiAction } from '../../../core/services/http/apiAction';
import maintenanceConstants from './maintenanceConstants';
import {
  GET_MAINTENANCE_RECORDS_REQUEST,
  GET_MAINTENANCE_RECORDS_SUCCESS,
  GET_MAINTENANCE_RECORDS_ERROR,
  GET_MAINTENANCE_RECORD_REQUEST,
  GET_MAINTENANCE_RECORD_SUCCESS,
  GET_MAINTENANCE_RECORD_ERROR,
  CREATE_MAINTENANCE_RECORD_REQUEST,
  CREATE_MAINTENANCE_RECORD_SUCCESS,
  CREATE_MAINTENANCE_RECORD_ERROR,
  GET_REPAIR_DETAILS_REQUEST,
  GET_REPAIR_DETAILS_SUCCESS,
  GET_REPAIR_DETAILS_ERROR,
  CREATE_REPAIR_RECORD_REQUEST,
  CREATE_REPAIR_RECORD_SUCCESS,
  CREATE_REPAIR_RECORD_ERROR,
  UPDATE_MAINTENANCE_RECORD_REQUEST,
  UPDATE_MAINTENANCE_RECORD_SUCCESS,
  UPDATE_MAINTENANCE_RECORD_ERROR,
  DELETE_REPAIR_RECORD_REQUEST,
  DELETE_REPAIR_RECORD_SUCCESS,
  DELETE_REPAIR_RECORD_ERROR,
} from './maintenanceActionTypes';

// Every thunk here previously carried its own ~40-line copy of the same
// status-code branching. `apiAction` owns that now, and each thunk resolves to
// `{ ok, data, message }` so callers can await the write before refetching.

const LIST_TYPES = [
  GET_MAINTENANCE_RECORDS_REQUEST,
  GET_MAINTENANCE_RECORDS_SUCCESS,
  GET_MAINTENANCE_RECORDS_ERROR,
];
const DETAIL_TYPES = [
  GET_MAINTENANCE_RECORD_REQUEST,
  GET_MAINTENANCE_RECORD_SUCCESS,
  GET_MAINTENANCE_RECORD_ERROR,
];
const REPAIR_LIST_TYPES = [GET_REPAIR_DETAILS_REQUEST, GET_REPAIR_DETAILS_SUCCESS, GET_REPAIR_DETAILS_ERROR];
const CREATE_TYPES = [
  CREATE_MAINTENANCE_RECORD_REQUEST,
  CREATE_MAINTENANCE_RECORD_SUCCESS,
  CREATE_MAINTENANCE_RECORD_ERROR,
];
const CREATE_REPAIR_TYPES = [CREATE_REPAIR_RECORD_REQUEST, CREATE_REPAIR_RECORD_SUCCESS, CREATE_REPAIR_RECORD_ERROR];
const UPDATE_TYPES = [
  UPDATE_MAINTENANCE_RECORD_REQUEST,
  UPDATE_MAINTENANCE_RECORD_SUCCESS,
  UPDATE_MAINTENANCE_RECORD_ERROR,
];
const DELETE_REPAIR_TYPES = [DELETE_REPAIR_RECORD_REQUEST, DELETE_REPAIR_RECORD_SUCCESS, DELETE_REPAIR_RECORD_ERROR];

// ---------------------------------------------------------------------------
// Reads
// ---------------------------------------------------------------------------

export const getMaintenanceRecords = (payload) =>
  apiAction({ types: LIST_TYPES, url: maintenanceConstants.GET_MAINTENANCE_RECORDS(payload) });

export const searchMaintenanceRecords = (payload) =>
  apiAction({ types: LIST_TYPES, url: maintenanceConstants.SEARCH_MAINTENANCE_RECORDS(payload) });

export const getOnsiteMaintenanceRecords = (payload) =>
  apiAction({ types: LIST_TYPES, url: maintenanceConstants.GET_ONSITE_MAINTENANCE_RECORDS(payload) });

export const getOffsiteMaintenanceRecords = (payload) =>
  apiAction({ types: LIST_TYPES, url: maintenanceConstants.GET_OFFSITE_MAINTENANCE_RECORDS(payload) });

export const getAssetMaintenanceRecords = (payload) =>
  apiAction({ types: LIST_TYPES, url: maintenanceConstants.GET_ASSET_MAINTENANCE_RECORDS(payload) });

export const getMaintenanceRecord = (id) =>
  apiAction({ types: DETAIL_TYPES, url: maintenanceConstants.GET_MAINTENANCE_RECORD(id) });

export const getRepairDetail = (id, { page = 1, rowsPerPage = 10 } = {}) =>
  apiAction({ types: REPAIR_LIST_TYPES, url: maintenanceConstants.GET_REPAIR_DETAIL(id, { page, rowsPerPage }) });

// ---------------------------------------------------------------------------
// Writes — admin side
// ---------------------------------------------------------------------------

export const createMaintenanceRecord = (payload) =>
  apiAction({
    types: CREATE_TYPES,
    method: 'post',
    url: maintenanceConstants.CREATE_MAINTENANCE_RECORD,
    data: payload,
    toastOnSuccess: true,
  });

export const updateMaintenanceRecord = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'patch',
    url: maintenanceConstants.UPDATE_MAINTENANCE_RECORD(id),
    data: payload,
    toastOnSuccess: true,
  });

export const updateMaintenanceStatus = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.UPDATE_STATUS(id),
    data: payload,
    toastOnSuccess: true,
  });

export const approveMaintenanceRecord = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.APPROVE_MAINTENANCE(id),
    data: payload,
    toastOnSuccess: true,
  });

// Admin rejecting the request itself.
export const ManagerDecline = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.DECLINE_MAINTENANCE(id),
    data: payload,
    toastOnSuccess: true,
  });

// ---------------------------------------------------------------------------
// Writes — service provider side
// ---------------------------------------------------------------------------

export const serviceProviderAcceptance = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.SP_REPAIR_ACCEPTANCE(id),
    data: payload,
    toastOnSuccess: true,
  });

export const serviceProviderDecline = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.SP_REPAIR_DECLINE(id),
    data: payload,
    toastOnSuccess: true,
  });

export const createRepairRecord = (payload) =>
  apiAction({
    types: CREATE_REPAIR_TYPES,
    method: 'post',
    url: maintenanceConstants.CREATE_REPAIR_RECORD,
    data: payload,
    toastOnSuccess: true,
  });

export const updateRepairRecord = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'put',
    url: maintenanceConstants.UPDATE_REPAIR_RECORD(id),
    data: payload,
    toastOnSuccess: true,
  });

export const deleteRepairRecord = (id) =>
  apiAction({
    types: DELETE_REPAIR_TYPES,
    method: 'delete',
    url: maintenanceConstants.DELETE_REPAIR_RECORD(id),
    toastOnSuccess: true,
  });

// ---------------------------------------------------------------------------
// Return handshake
// ---------------------------------------------------------------------------

export const maintenanceReturnRequest = (id) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.RETURN_REQUEST(id),
    toastOnSuccess: true,
  });

export const acceptReturnRequest = (id) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.ACCEPT_RETURN_REQUEST(id),
    toastOnSuccess: true,
  });

export const declineReturnRequest = ({ id, payload }) =>
  apiAction({
    types: UPDATE_TYPES,
    method: 'post',
    url: maintenanceConstants.DECLINE_RETURN_REQUEST(id),
    data: payload,
    toastOnSuccess: true,
  });
